import React from 'react';

export const LogoutWhiteIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M3.33333 14.5006C2.96667 14.5006 2.65289 14.3702 2.392 14.1093C2.13111 13.8484 2.00044 13.5344 2 13.1673V3.83394C2 3.46728 2.13067 3.1535 2.392 2.89261C2.65333 2.63172 2.96711 2.50105 3.33333 2.50061H8V3.83394H3.33333V13.1673H8V14.5006H3.33333ZM10.6667 11.8339L9.75 10.8673L11.45 9.16728H6V7.83394H11.45L9.75 6.13394L10.6667 5.16728L14 8.50061L10.6667 11.8339Z"
        fill="white"
      />
    </svg>
  );
};
